<div class="modal-wrapper">
  <div class="overlay" *ngIf="blockThisUI">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ reportOptions.name }} Report</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="this.showTestedPartiesSelection">
      <div class="row">
        <div class="col-lg-6" *ngIf="hasTestedParties">
          <span class="ey-float-label">
            <select
              class="form-control tested-party-select form-select"
              id="TestedPartySelect"
              name="TestedPartySelect"
              [(ngModel)]="selectedTestedParty"
              appLabelFloat
            >
              <option *ngFor="let testedParty of testedParties" [ngValue]="testedParty">{{ testedParty.testedPartyName }}</option>
            </select>
            <label for="TestedPartySelect">Tested Party</label>
          </span>
        </div>
        <div class="col-lg-6" *ngIf="!hasTestedParties">
          <span class="no-tested-party"> No Tested Party available </span>
        </div>
      </div>
    </div>
    <div *ngIf="showGeneralInfo">
      <div class="row columns-heading">
        <div class="col-12">General Information</div>
      </div>
      <div class="row disclaimer">
        <div class="col-12">* Note: This data will always be generated *</div>
      </div>
    </div>
    <div class="row" *ngIf="defaultColumns.length > 0">
      <div class="col-12">
        <div class="default-columns">
          <div class="default-column" *ngFor="let column of defaultColumns"><i class="material-icons check-icon">done</i>{{ column }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="isSelectionAvailable()">
      <div class="row columns-heading">
        <div class="col-12">Optional Columns</div>
      </div>
      <div class="row">
        <div class="col-12 disclaimer">Note: Drag the column name to the right that you would like to include in your report</div>
      </div>
      <div class="row">
        <div class="col-12">
          <p-pickList
            [source]="optionalColumns"
            [target]="selections"
            [dragdrop]="true"
            [responsive]="true"
            styleClass="reports-optional-col-selector"
            [showSourceControls]="false"
            [showTargetControls]="false"
          >
            <ng-template pTemplate="emptymessagetarget"> DRAG HERE </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="export-option-card">
                <div class="d-table">
                  <div class="d-table-cell">
                    <i class="material-icons drag-icon">more_vert</i>
                  </div>
                  <div class="d=table-cell">
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </ng-template>
          </p-pickList>
        </div>
      </div>
    </div>
    <div *ngIf="showContemporaryOptions">
      <div class="row columns-heading">
        <div class="col-12">Please choose the following options</div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="optionYtd"
              name="contemporaryReportTypeOption"
              class="custom-control-input"
              [value]="0"
              [(ngModel)]="contemporaryReportTypeSelection"
            />
            <label class="custom-control-label form-check-label" for="optionYtd">YTD (Year To Date)</label>
          </div>
        </div>
        <div class="col-12">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="optionLtm"
              name="contemporaryReportTypeOption"
              class="custom-control-input"
              [value]="1"
              [(ngModel)]="contemporaryReportTypeSelection"
            />
            <label class="custom-control-label form-check-label" for="optionLtm">LTM (Last Twelve Months)</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ngb-alert *ngIf="message?.length > 0" (close)="message = ''" [type]="type">{{ message }}</ngb-alert>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <div *ngIf="reportTemplate === reportType.DetailedPLISummary; else elseBlock">
      <button type="button" class="btn btn-default" (click)="generateGeneralReport()">Generate Report</button>
    </div>
    <ng-template #elseBlock>
      <button type="button" class="btn btn-default" (click)="generatePreliminaryReport()" *ngIf="!isSingleReport()">
        Generate Preliminary Report
      </button>
      <button type="button" class="btn btn-default" (click)="generateFinalReport()" *ngIf="!isSingleReport()">Generate Final Report</button>

      <button type="button" class="btn btn-default" (click)="generateGeneralReport()" *ngIf="isSingleReport()">Generate Report</button>
    </ng-template>
  </div>
</div>
